export default {
    orderTable: {
        accept: {},
        allocate: {},
        pickup: {},
    },
    order: null,
    orderHistory: [],
    pendingOrder: {},
};
